import { render, staticRenderFns } from "./PdfManagement.vue?vue&type=template&id=12304223&scoped=true&"
import script from "./PdfManagement.vue?vue&type=script&lang=js&"
export * from "./PdfManagement.vue?vue&type=script&lang=js&"
import style0 from "./PdfManagement.vue?vue&type=style&index=0&id=12304223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12304223",
  null
  
)

export default component.exports